<ng-container *ngIf="!item.hidden">
  <!-- collapsible title -->
  <a
    class="d-flex align-items-center"
    [ngClass]="item.classes"
    *ngIf="!item.url"
    (click)="toggleOpen($event)"
  >
    <ng-container *ngTemplateOutlet="itemContent"></ng-container>
  </a>

  <!-- itemContent template -->
  <ng-template #itemContent>
    <span
      [data-feather]="item.icon"
      *ngIf="item.icon && item.isFeatherIcon; else notFeatherIcon"
    ></span>
    <ng-template #notFeatherIcon>
      <svg
        width="14"
        height="14"
        fill="none"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        [innerHTML]="svgContent"
      ></svg>
    </ng-template>
    <span class="menu-title text-truncate" [translate]="item.translate">{{
      item.title
    }}</span>
    <span
      class="badge ml-auto mr-1"
      *ngIf="item.badge"
      [translate]="item.badge.translate"
      [ngClass]="item.badge.classes"
    >
      {{ item.badge.title }}
    </span>
  </ng-template>

  <!-- sub-menu item/collapsible -->
  <ul class="menu-content">
    <ng-container *ngFor="let item of item.children">
      <!-- item -->
      <li
        core-menu-vertical-item
        [item]="item"
        *ngIf="item.type == 'item'"
        class="sub-menu"
        [ngClass]="{ disabled: item.disabled === true }"
        [routerLinkActive]="!item.openInNewTab ? 'active' : ''"
        [routerLinkActiveOptions]="{ exact: item.exactMatch || false }"
      >
        <span
          [routerLink]="item.openInNewTab ? [] : [item.url]"
          class="d-none"
        ></span>
      </li>
      <!-- collapsible -->
      <li
        core-menu-vertical-collapsible
        *ngIf="item.type == 'collapsible'"
        [item]="item"
        class="nav-item has-sub sub-menu-2"
      ></li>
    </ng-container>
  </ul>
</ng-container>

<style>
  .sub-menu{
    a {
      svg {
        display: none !important;
      }
    }    
  }
  .sub-menu-2{
    a {
      svg {
        display: none !important;
      }
    }    
    .sub-menu{
    a {
      padding-left: 35px !important;
    }    
  }
  }

</style>
